import { featuredBrands } from "@/mocks/home";

export default function BrandShowcase() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            精选品牌
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自亚洲各国的优质品牌，每个品牌都承载着独特的匠心与文化
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredBrands.map((brand, i) => (
            <div
              key={i}
              className="group rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={brand.image}
                  alt={brand.name}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4 text-center">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950">
                  {brand.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-600">
                  {brand.origin} · {brand.category}
                </p>
                <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {brand.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}